import {injectable} from 'inversify';

import type {TextQuestionModel} from '../../Question/TextQuestion/TextQuestion.model';
import type {AnswerModelProps} from '../Answer.model';

import {TextAnswerModel} from './TextAnswer.model';

@injectable()
export class TextAnswerFactory {
  create(props: AnswerModelProps<string, TextQuestionModel>) {
    return new TextAnswerModel(props);
  }
}
